import React, { useState, useEffect } from 'react';
import './Loader.css';

export default function Loader({ progress }) {
  const [phase, setPhase] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 200);
    const t2 = setTimeout(() => setPhase(2), 800);
    const t3 = setTimeout(() => setPhase(3), 1400);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  useEffect(() => {
    if (progress >= 100) setTimeout(() => setDone(true), 300);
  }, [progress]);

  return (
    <div className={`loader ${done ? 'loader--done' : ''}`}>
      {/* Background particles */}
      <canvas id="loader-canvas" ref={el => {
        if (!el || el.dataset.init) return;
        el.dataset.init = '1';
        const ctx = el.getContext('2d');
        let W = el.width = window.innerWidth, H = el.height = window.innerHeight;
        const particles = [];
        for (let i = 0; i < 80; i++) particles.push({
          x: Math.random() * W, y: Math.random() * H,
          r: Math.random() * 1.5 + 0.3, vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3,
          a: Math.random() * 0.3 + 0.05
        });
        let frame = 0;
        const loop = () => {
          ctx.clearRect(0, 0, W, H);
          const bg = ctx.createRadialGradient(W/2, H/2, 0, W/2, H/2, Math.max(W,H)*0.6);
          bg.addColorStop(0, '#020025'); bg.addColorStop(1, '#000005');
          ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
          frame++;
          particles.forEach(p => {
            p.x += p.vx; p.y += p.vy;
            if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
            if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
            const flicker = p.a + Math.sin(frame * 0.02 + p.x) * 0.1;
            ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.28);
            ctx.fillStyle = `rgba(165,42,58,${Math.max(0, flicker)})`;
            ctx.fill();
          });
          requestAnimationFrame(loop);
        };
        loop();
        window.addEventListener('resize', () => { W = el.width = window.innerWidth; H = el.height = window.innerHeight; });
      }} />

      <div className="loader__content">
        {/* Logo */}
        <div className={`loader__logo ${phase >= 1 ? 'show' : ''}`}>
          <div className="loader__logo-glow" />
          <div className="loader__logo-ring loader__logo-ring--1" />
          <div className="loader__logo-ring loader__logo-ring--2" />
          <img src="/logo.png" alt="BNFT" className="loader__logo-img" />
        </div>

        {/* Title */}
        <div className={`loader__title ${phase >= 2 ? 'show' : ''}`}>
          <span className="loader__title-mi">BNFT</span>
          <span className="loader__title-nft">NFT</span>
        </div>

        {/* Progress */}
        <div className={`loader__progress ${phase >= 3 ? 'show' : ''}`}>
          <div className="loader__bar">
            <div className="loader__bar-fill" style={{ width: progress + '%' }} />
            <div className="loader__bar-glow" style={{ left: progress + '%' }} />
          </div>
          <div className="loader__percent">
            <span className="loader__percent-num">{progress}</span>
            <span className="loader__percent-sign">%</span>
          </div>
          <div className="loader__status">
            {progress < 30 ? 'INITIALIZING BLOCKCHAIN INTERFACE...' :
             progress < 60 ? 'LOADING SMART CONTRACTS...' :
             progress < 90 ? 'CONNECTING TO BEP-20 NETWORK...' :
             'SYSTEM READY'}
          </div>
        </div>

        {/* Decorative lines */}
        <div className={`loader__lines ${phase >= 2 ? 'show' : ''}`}>
          <div className="loader__line loader__line--l" />
          <div className="loader__line loader__line--r" />
        </div>
      </div>

      {/* Corner brackets */}
      <div className={`loader__corner loader__corner--tl ${phase >= 1 ? 'show' : ''}`} />
      <div className={`loader__corner loader__corner--tr ${phase >= 1 ? 'show' : ''}`} />
      <div className={`loader__corner loader__corner--bl ${phase >= 1 ? 'show' : ''}`} />
      <div className={`loader__corner loader__corner--br ${phase >= 1 ? 'show' : ''}`} />

      {/* Scan line */}
      <div className="loader__scan" />
    </div>
  );
}
